export default __webpack_public_path__ + "static/home-men-mobile-pattern-a6fef4503d76a48a7cd568489201bdb5.svg";